<template>
    <v-card>
        <v-card-title>絶対表:月別</v-card-title>
            <v-sheet tile height="6vh" class="d-flex align-center">
                <v-container>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col lg="3" sm="6" cols="12">
                            <v-select
                                v-model="shop_id"
                                :items="shops"
                                label="支店"
                                @change="changeShop"
                                style="min-width: min-content;"
                            ></v-select>
                        </v-col>
                        <v-col lg="3" sm="6" cols="12">
                            <v-select
                                v-model="target_month"
                                :items="monthes"
                                label="期間"
                                @change="changeMonth"
                                style="min-width: min-content;"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
        <v-card-text>
            <v-data-table
                :headers="countHeaders"
                :items="counts"
                :server-items-length="counts.length"
                :loading="loading"
                hide-default-footer
                dense
                class="elevation-1"
            >
                <template v-slot:[`item.shift_rate`]="{ item }">
                    {{shiftRate(item)}}％
                </template>
            </v-data-table><br>
            <h4>1年目</h4>
            <v-data-table
                :headers="headers"
                :items="firstCustomers"
                :server-items-length="firstCustomers.length"
                :loading="loading"
                hide-default-footer
                dense
                class="elevation-1"
            >
                <template v-slot:[`item.shop`]="{ item }">
                    {{showShop(item.shop_id)}}
                </template>
                <template v-slot:[`item.age`]="{ item }">
                    {{calcAge(item.birthday)}}歳
                </template>
                <template v-slot:[`item.is_shift`]="{ item }">
                    {{item.is_shift ? "済": ""}}
                </template>
                <template v-slot:[`item.year`]="{ item }">
                    {{item.year}}年目
                </template>
                <template v-slot:[`item.counselor`]="{ item }">
                    {{showCounselor(item.counselor_id)}}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    {{showStatus(item)}}
                </template>
            </v-data-table><br>
            <h4>2年目以降</h4>
            <v-data-table
                :headers="headers"
                :items="secondCustomers"
                :server-items-length="secondCustomers.length"
                :loading="loading"
                hide-default-footer
                dense
                class="elevation-1"
            >
                <template v-slot:[`item.shop`]="{ item }">
                    {{showShop(item.shop_id)}}
                </template>
                <template v-slot:[`item.age`]="{ item }">
                    {{calcAge(item.birthday)}}歳
                </template>
                <template v-slot:[`item.is_shift`]="{ item }">
                    {{item.is_shift ? "済": ""}}
                </template>
                <template v-slot:[`item.year`]="{ item }">
                    {{item.year}}年目
                </template>
                <template v-slot:[`item.counselor`]="{ item }">
                    {{showCounselor(item.counselor_id)}}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    {{showStatus(item)}}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"

export default {
    title: "会員数状況:支店別",
    name: "customer_shift_month",
    mixins: [utilDatetime],
    data: () => ({
        target_month: 0,
        shop_id: 0,
        loading: false,
        countHeaders: [
            { text: "", value: "kind", align: "left", sortable: false },
            { text: "シフト対象数", value: "target_count", align: "center", sortable: false },
            { text: "結果シフト数", value: "shift_count", align: "center", sortable: false },
            { text: "シフト率", value: "shift_rate", align: "center", sortable: false },
        ],
        counts: [],
        headers: [
            { text: "会員名", value: "name", align: "left", sortable: false, width: "18%" },
            { text: "支店", value: "shop", align: "left", sortable: false, width: "12%" },
            { text: "年齢", value: "age", align: "center", sortable: false, width: "6%" },
            { text: "初入会日", value: "contract_date", align: "center", sortable: false, width: "10%" },
            { text: "シフト契約", value: "is_shift", align: "center", sortable: false, width: "6%" },
            { text: "活動年数", value: "year", align: "center", sortable: false, width: "8%" },
            { text: "担当CO", value: "counselor", align: "left", sortable: false, width: "10%" },
            { text: "コース", value: "status", align: "left", sortable: false, width: "12%" },
            { text: "住所", value: "address", align: "left", sortable: false, width: "18%" },

        ],
        firstCustomers: [],
        secondCustomers: [],
        shops: null,
        counselors: [],
        courses: [],
    }),
    async mounted() {
        const now = new Date();
        const defaultDate = new Date(now);
        defaultDate.setMonth(now.getMonth() + 2);
        const defaultYear = defaultDate.getFullYear();
        const defaultMonth = defaultDate.getMonth() + 1;
        const defaultValue = `${defaultYear}-${("00"+defaultMonth).slice(-2)}`;
        
        const defaultMonthExists = this.monthes.find(m => m.value === defaultValue);
        if (defaultMonthExists) {
            this.target_month = defaultValue;
        } else {
            this.target_month = this.monthes[0].value;
        }
        
        await this.getList();
    },
    computed: {
        monthes() {
            const monthes = [];
            const now = new Date();
            
            let year = now.getFullYear();
            let month = now.getMonth() + 1;
            
            while(year > 2021 || month >= 6) {
                monthes.push({
                    text: `${year}年${month}月`,
                    value: `${year}-${("00"+month).slice(-2)}`
                });
                --month;
                if(month <= 0) {
                    --year;
                    month = 12;
                }
            }
            
            for (let i = 1; i <= 11; i++) {
                const futureDate = new Date(now.getFullYear(), now.getMonth() + i, 1);
                const futureYear = futureDate.getFullYear();
                const futureMonth = futureDate.getMonth() + 1;
                
                monthes.push({
                    text: `${futureYear}年${futureMonth}月`,
                    value: `${futureYear}-${("00"+futureMonth).slice(-2)}`
                });
            }
            
            monthes.sort((a, b) => {
                const dateA = new Date(a.value + '-01');
                const dateB = new Date(b.value + '-01');
                return dateB - dateA;
            });

            return monthes;
        },
    },
    methods: {
        async getShopId() {
            if(this.shops == null) {
                await this.$axios.get( `/api/v1/shop`)
                    .then( response => {
                        console.log(response)
                        this.shops = response.data.shops;
                    })
                const shop_id = this.$store.state.user.shop_id || this.shops[0].value;
                this.shop_id = shop_id;
            }
            return this.shop_id;
        },
        async getList() {
            this.loading = true;
            const shop_id = await this.getShopId();

            await this.$axios.get( `/api/v1/customer_shift/month/${shop_id}/${this.target_month}`)
                .then( response => {
                    this.firstCustomers = response.data.firstCustomers;
                    this.secondCustomers = response.data.secondCustomers;

                    this.shops = response.data.shops;
                    this.counselors = response.data.counselors;
                    this.courses = response.data.courses;

                    const firstCount = {
                        kind: "1年目",
                        target_count: this.firstCustomers.length,
                        shift_count: this.firstCustomers.filter(c => c.is_shift).length,
                    }
                    const secondCount = {
                        kind: "2年目以降",
                        target_count: this.secondCustomers.length,
                        shift_count: this.secondCustomers.filter(c => c.is_shift).length,
                    }
                    const totalCount = {
                        kind: "合計",
                        target_count: firstCount.target_count + secondCount.target_count,
                        shift_count: firstCount.shift_count + secondCount.shift_count,
                    }
                    this.counts = [];
                    this.counts.push(totalCount)
                    this.counts.push(firstCount)
                    this.counts.push(secondCount)
                })
                .catch( error => {
                    console.log(error);
                });
            this.loading = false;
        },
        changeShop() {
            this.getList();
        },
        changeMonth() {
            this.getList();
        },
        shiftRate(item) {
            if(item.target_count == 0) return 0;
            return Math.floor(item.shift_count / item.target_count * 100)
        },
        showShop(shopId) {
            const shop = this.shops.find(s => s.value == shopId);
            if(shop) return shop.text;
            return "無し"
        },
        showCounselor(counselorId) {
            const counselor = this.counselors.find(c => c.id == counselorId);
            if(counselor) return counselor.name;
            return "無し"
        },
        showStatus(item) {
            if(item.is_exit) {
                return CUSTOMER.EXIT_REASON.getName(item.exit_reason);
            }
            const course = this.courses.find(c => c.id == item.course_id);
            if(course) return course.name;
            return "";
        },
    },
};
</script>
